import React, { useState, useEffect } from 'react';
import ImageWithSkeleton from './ImageWithSkeleton';
import { useBranding } from '../branding/BrandingProvider';
import env from '../../../../package.json';

const LogoWithSkeleton = ({
    className = '',
    skeletonWidth = '7vw',
    skeletonHeight = '7vw',
    skeletonShape = 'circle',
    ...props
}) => {
    const { brandingSettings } = useBranding();
    const [logoUrl, setLogoUrl] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const loadLogo = async () => {
            setIsLoading(true);

            try {
                // Если есть настройки брендинга с логотипом
                if (brandingSettings?.logo_url) {
                    let finalLogoUrl = brandingSettings.logo_url;

                    // Если это путь к файлу, формируем полный URL
                    if (finalLogoUrl.startsWith('/files/')) {
                        finalLogoUrl = `${env.nodeHost}${finalLogoUrl}`;
                    }

                    setLogoUrl(finalLogoUrl);
                } else {
                    // Используем дефолтный логотип
                    setLogoUrl(require('assets/icon/logo.png'));
                }
            } catch (error) {
                console.warn('Ошибка загрузки логотипа:', error);
                setLogoUrl(require('assets/icon/logo.png'));
            } finally {
                setIsLoading(false);
            }
        };

        loadLogo();
    }, [brandingSettings?.logo_url]);

    return (
        <ImageWithSkeleton
            src={logoUrl}
            alt="Логотип"
            className={className}
            skeletonWidth={skeletonWidth}
            skeletonHeight={skeletonHeight}
            skeletonShape={skeletonShape}
            fallbackSrc={require('assets/icon/logo.png')}
            {...props}
        />
    );
};

export default LogoWithSkeleton;
